import React, { FC, KeyboardEvent, ReactNode, useCallback } from 'react';

import ChevronRight from '@gravity-ui/icons/ChevronRight';
import TrashBin from '@gravity-ui/icons/TrashBin';
import { Button, Icon } from '@gravity-ui/uikit';

import styles from './AliceExternalAppEditPage.module.scss';

interface Props {
    expanded: boolean;
    onToggle: () => void;
    onRemove: () => void;
    removeDisabled: boolean;
    title: ReactNode;
}

/**
 * Clickable card header shared by ToolCard and ResourceCard. Owns the chevron rotation, the
 * keyboard handler (Enter/Space toggles), and the remove button (with `stopPropagation` so the
 * delete click doesn't also toggle the card).
 */
export const CardHeader: FC<Props> = ({ expanded, onToggle, onRemove, removeDisabled, title }) => {
    const handleKeyDown = useCallback(
        (e: KeyboardEvent<HTMLDivElement>) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onToggle();
            }
        },
        [onToggle],
    );

    return (
        <div className={styles.cardHeader} role="button" tabIndex={0} onClick={onToggle} onKeyDown={handleKeyDown}>
            <span className={styles.cardHeaderTitle}>
                <span className={`${styles.cardHeaderChevron} ${expanded ? styles.cardHeaderChevronExpanded : ''}`}>
                    <Icon data={ChevronRight} size={16} />
                </span>
                {title}
            </span>
            <Button
                view="flat"
                disabled={removeDisabled}
                onClick={(e) => {
                    e.stopPropagation();
                    onRemove();
                }}
            >
                <Icon data={TrashBin} />
            </Button>
        </div>
    );
};
